@if (data) {
  <div class="img-container">
    @if (data.url) {
      <img
        src="{{ data.url }}"
        (load)="onImageLoaded()"
        alt="image"
        [style.border-radius]="data.borderRadius + 'px'"
      />
    }
  </div>
}
